import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { DBkeys } from './db-Keys';
import { HttpClient } from '@angular/common/http';

import { Utilities } from '../../shared/utilities/utilities';
import { environment } from '../../environments/environment';
import { LocalStoreManager } from './local-store-manager.service';



@Injectable()
export class ConfigurationService {
  ////public baseUrl = environment.baseUrl || Utilities.baseUrl();
  public webApiUrl = environment.WebApiUrl;
 
  public loginUrl = environment.loginUrl;
  public logoutUrl = environment.logoutUrl;
  public static readonly defaultHomeUrl: string = "/";

  private configuration: IServerConfiguration;
  private appConfig: any;
  private _homeUrl: string = null;
  private _language: string = null;

  constructor(private location: Location, private localStorage: LocalStoreManager, private http: HttpClient) {
    this.loadLocalChanges();
  }

  private loadLocalChanges() {
    if (this.localStorage.exists(DBkeys.HOME_URL))
      this._homeUrl = this.localStorage.getDataObject<string>(DBkeys.HOME_URL);
      this.configuration = this.localStorage.getDataObject<IServerConfiguration>(DBkeys.APPCONSTS);
  }

  get getSiteKey() {
    return this.configuration.SiteKey;
  }

  get getSecretKey() {
    return this.configuration.SecretKey;
  }

  get getReportURL() {
    return this.configuration.ReportUrl;
  }

  get getReportPowerBiURL() {
    return this.configuration.ReportPowerBiUrl;
  }

  get getExternalWebsiteMode() {
    return this.configuration.ExternalWebsiteMode;
  }

  set homeUrl(value: string) {
    this._homeUrl = value;
    this.saveToLocalStore(value, DBkeys.HOME_URL);
  }

  get homeUrl() {
    if (this._homeUrl != null)
      return this._homeUrl;

    return ConfigurationService.defaultHomeUrl;
  }

  get baseUrl() {
     return this.configuration.BaseUrl;
  }

   get ssoLoginUrl() {
     return this.configuration.LoginUrl;
   }

   get ssoLogoutUrl() {

     return this.configuration.LogoutUrl;
  }

  private saveToLocalStore(data: any, key: string) {
    setTimeout(() => this.localStorage.savePermanentData(data, key));
  }

  loadConfig() {
   
   //Check if External site
    if (Utilities.baseUrl().search('alberta.ca') > -1) {
      return this.http.get<IServerConfiguration>('/app/api/Configuration/ConfigurationData')
        .toPromise()
        .then(result => {
          this.configuration = <IServerConfiguration>(result);
          this.saveToLocalStore(this.configuration, DBkeys.APPCONSTS);
        },
          error => console.error(error));
    } else {
      return this.http.get<IServerConfiguration>('/api/Configuration/ConfigurationData')
        .toPromise()
        .then(result => {
          this.configuration = <IServerConfiguration>(result);
          this.saveToLocalStore(this.configuration, DBkeys.APPCONSTS);
        }, error => console.error(error));
    }
  }
}

export interface IServerConfiguration {
  WebApiUrl: string;
  ReportUrl: string;
  ReportPowerBiUrl: string;
  ExternalWebsiteMode: string;
  BaseUrl: string;
  LoginUrl: string;
  LogoutUrl: string;
  SiteKey: string;
  SecretKey: string;
}
